import { shallowEqual, useSelector } from 'react-redux';
import { getTicketsRefillEvent } from '../selectors';

export const useTicketsRefillEvent = () => ({
  tickets: useSelector(getTicketsRefillEvent, shallowEqual),
});
